import React, { useState } from "react";
import "../../Styles/EventsTable.css";
import { useNavigate } from "react-router-dom";

const AdminEventsTable = () => {
  const navigate = useNavigate();

  const initialData = [
    {
      id: 1,
      title: "Road Development Foundation Stone",
      type: "Inauguration",
      venue: "Main Bus Stand Road, Gudluru",
      village: "Gudluru Village",
      mandal: "Gudluru Mandal",
      date: "25-07-2026",
      day: "Saturday",
      month: "JUL",
      dateNum: "25",
      time: "10:30 AM",
      status: "Upcoming",
      image:
        "https://images.unsplash.com/photo-1590496793929-36417d3117de?w=200&h=150&fit=crop",
      badgeColor: "evt123-badge-blue",
    },
    {
      id: 2,
      title: "Ward Level Grievance Camp",
      type: "Grievance Camp",
      venue: "ZP High School Grounds, Kandukur",
      village: "Kandukur Village",
      mandal: "Kandukur Mandal",
      date: "20-07-2026",
      day: "Sunday",
      month: "JUL",
      dateNum: "20",
      time: "9:00 AM",
      status: "Completed",
      image:
        "https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=200&h=150&fit=crop",
      badgeColor: "evt123-badge-green",
    },
    {
      id: 3,
      title: "Farmers Review Meeting",
      type: "Review Meeting",
      venue: "Mandal Parishad Office, Ulavapadu",
      village: "Ulavapadu Village",
      mandal: "Ulavapadu Mandal",
      date: "28-07-2026",
      day: "Tuesday",
      month: "JUL",
      dateNum: "28",
      time: "4:00 PM",
      status: "Upcoming",
      image:
        "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=200&h=150&fit=crop",
      badgeColor: "evt123-badge-purple",
    },
  ];

  const [events, setEvents] = useState(initialData);

  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All Types");
  const [mandalFilter, setMandalFilter] = useState("All Mandals");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const totalPages = 8;

  const resetFilters = () => {
    setSearch("");
    setTypeFilter("All Types");
    setMandalFilter("All Mandals");
    setStatusFilter("All Status");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ---------- SEARCH + FILTER LOGIC ----------
  const filteredEvents = events.filter((item) => {
    const searchLower = search.trim().toLowerCase();

    const matchesSearch =
      searchLower === "" ||
      item.title.toLowerCase().includes(searchLower) ||
      item.venue.toLowerCase().includes(searchLower);

    const matchesType = typeFilter === "All Types" || item.type === typeFilter;

    const matchesMandal =
      mandalFilter === "All Mandals" ||
      item.mandal.toLowerCase().includes(mandalFilter.toLowerCase());

    const matchesStatus =
      statusFilter === "All Status" || item.status === statusFilter;

    return matchesSearch && matchesType && matchesMandal && matchesStatus;
  });

  // ---------- EDIT LOGIC ----------
  const openEditModal = (item) => {
    setEditItem({ ...item });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditItem(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setEvents((prev) =>
      prev.map((item) => (item.id === editItem.id ? editItem : item))
    );
    closeEditModal();
  };

  // ---------- STATS ----------
  const totalEvents = events.length;
  const upcomingEvents = events.filter((e) => e.status === "Upcoming").length;
  const completedEvents = events.filter((e) => e.status === "Completed").length;
  const cancelledEvents = events.filter((e) => e.status === "Cancelled").length;

  const getStatusClass = (status) => {
    switch (status) {
      case "Upcoming":
        return "evt123-status-upcoming";
      case "Completed":
        return "evt123-status-completed";
      case "Cancelled":
        return "evt123-status-cancelled";
      default:
        return "";
    }
  };

  return (
    <div className="evt123-page">
      {/* Header */}
      <div className="evt123-header">
        <div>
          <h2 className="evt123-title">Events</h2>
          <p className="evt123-subtitle">
            Manage and organize all public events and programs.
          </p>
        </div>

        <button
          className="evt123-add-btn"
          onClick={() => navigate("/AdminDashboard/EventsForm")}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
            <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
          Add New Event
        </button>
      </div>

      {/* Stat Cards */}
      <div className="evt123-stats-grid">
        <div className="evt123-stat-card evt123-stat-card-blue">
          <div className="evt123-stat-icon evt123-stat-icon-blue">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>
          <div className="evt123-stat-info">
            <span className="evt123-stat-label">Total Events</span>
            <span className="evt123-stat-value">{totalEvents}</span>
            <span className="evt123-stat-sub">This Month</span>
          </div>
        </div>

        <div className="evt123-stat-card evt123-stat-card-green">
          <div className="evt123-stat-icon evt123-stat-icon-green">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
              <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="evt123-stat-info">
            <span className="evt123-stat-label">Upcoming</span>
            <span className="evt123-stat-value">{upcomingEvents}</span>
            <span className="evt123-stat-sub">Upcoming Events</span>
          </div>
        </div>

        <div className="evt123-stat-card evt123-stat-card-purple">
          <div className="evt123-stat-icon evt123-stat-icon-purple">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
              <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="evt123-stat-info">
            <span className="evt123-stat-label">Completed</span>
            <span className="evt123-stat-value">{completedEvents}</span>
            <span className="evt123-stat-sub">Completed Events</span>
          </div>
        </div>

        <div className="evt123-stat-card evt123-stat-card-red">
          <div className="evt123-stat-icon evt123-stat-icon-red">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
              <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>
          <div className="evt123-stat-info">
            <span className="evt123-stat-label">Cancelled</span>
            <span className="evt123-stat-value">{cancelledEvents}</span>
            <span className="evt123-stat-sub">Cancelled Events</span>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="evt123-filters">
        <div className="evt123-search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
            <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search Event..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <select
          className="evt123-select"
          value={typeFilter}
          onChange={(e) => {
            setTypeFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Types</option>
          <option>Inauguration</option>
          <option>Public Meeting</option>
          <option>Review Meeting</option>
          <option>Felicitation</option>
          <option>Grievance Camp</option>
          <option>Cultural Event</option>
          <option>Other</option>
        </select>

        <select
          className="evt123-select"
          value={mandalFilter}
          onChange={(e) => {
            setMandalFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Mandals</option>
          <option>Kandukur</option>
          <option>Gudluru</option>
          <option>Ulavapadu</option>
        </select>

        <select
          className="evt123-select"
          value={statusFilter}
          onChange={(e) => {
            setStatusFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Status</option>
          <option>Upcoming</option>
          <option>Completed</option>
          <option>Cancelled</option>
        </select>

        <button className="evt123-reset-btn" onClick={resetFilters}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4v6h6M20 20v-6h-6M4.5 15a8 8 0 0014.5 3.5M19.5 9A8 8 0 005 5.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Clear Filters
        </button>
      </div>

      {/* Event Cards */}
      <div className="evt123-list">
        {filteredEvents.length === 0 ? (
          <div className="evt123-no-data">No events found.</div>
        ) : (
          filteredEvents.map((item) => (
            <div className="evt123-card" key={item.id}>
              <div className={`evt123-date-badge ${item.badgeColor}`}>
                <span className="evt123-date-month">{item.month}</span>
                <span className="evt123-date-num">{item.dateNum}</span>
                <span className="evt123-date-year">
                  {item.date.split("-")[2]}
                </span>
                <span className="evt123-date-day">{item.day}</span>
              </div>

              <div className="evt123-thumb">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="evt123-card-body">
                <h3 className="evt123-card-title">{item.title}</h3>
                <span className="evt123-type-tag">{item.type}</span>

                <div className="evt123-card-meta">
                  <div className="evt123-meta-row">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinejoin="round"
                      />
                      <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.8" />
                    </svg>
                    {item.venue}
                  </div>

                  <div className="evt123-meta-row">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                      <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h1M9 13h1M14 9h1M14 13h1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    {item.village}, {item.mandal}
                  </div>
                </div>
              </div>

              <div className="evt123-card-schedule">
                <div className="evt123-meta-row">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
                    <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  {item.time}
                </div>

                <div className="evt123-meta-row">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
                    <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                  {item.date}
                </div>
              </div>

              <div className="evt123-card-status">
                <span className={`evt123-status-badge ${getStatusClass(item.status)}`}>
                  {item.status === "Upcoming" && (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                      <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  )}
                  {item.status === "Completed" && (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                      <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                  {item.status === "Cancelled" && (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                      <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  )}
                  {item.status}
                </span>
              </div>

              <div className="evt123-card-actions">
                <button className="evt123-edit-btn" onClick={() => openEditModal(item)}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Edit
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      <div className="evt123-pagination-bar">
        <span className="evt123-pagination-info">
          Showing 1 to {filteredEvents.length} of {totalEvents} events
        </span>

        <div className="evt123-pagination-controls">
          <button
            className="evt123-page-arrow"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            &lt;
          </button>

          {[1, 2, 3].map((p) => (
            <button
              key={p}
              className={`evt123-page-num ${currentPage === p ? "evt123-active" : ""}`}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </button>
          ))}

          <span className="evt123-page-dots">...</span>

          <button
            className={`evt123-page-num ${currentPage === totalPages ? "evt123-active" : ""}`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>

          <button
            className="evt123-page-arrow"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            &gt;
          </button>
        </div>
      </div>

      {/* ---------------- EDIT MODAL ---------------- */}
      {showEditModal && editItem && (
        <div className="evt123-modal-overlay" onClick={closeEditModal}>
          <div className="evt123-modal" onClick={(e) => e.stopPropagation()}>
            <div className="evt123-modal-header">
              <h3>Edit Event</h3>
              <button className="evt123-modal-close" onClick={closeEditModal}>
                &times;
              </button>
            </div>

            <form className="evt123-modal-body" onSubmit={handleEditSave}>
              <div className="evt123-form-group">
                <label>Event Title</label>
                <input
                  type="text"
                  name="title"
                  value={editItem.title}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="evt123-form-row">
                <div className="evt123-form-group">
                  <label>Type</label>
                  <select name="type" value={editItem.type} onChange={handleEditChange}>
                    <option>Inauguration</option>
                    <option>Public Meeting</option>
                    <option>Review Meeting</option>
                    <option>Felicitation</option>
                    <option>Grievance Camp</option>
                    <option>Cultural Event</option>
                    <option>Other</option>
                  </select>
                </div>

                <div className="evt123-form-group">
                  <label>Status</label>
                  <select name="status" value={editItem.status} onChange={handleEditChange}>
                    <option>Upcoming</option>
                    <option>Completed</option>
                    <option>Cancelled</option>
                  </select>
                </div>
              </div>

              <div className="evt123-form-group">
                <label>Venue</label>
                <input
                  type="text"
                  name="venue"
                  value={editItem.venue}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="evt123-form-row">
                <div className="evt123-form-group">
                  <label>Village</label>
                  <input
                    type="text"
                    name="village"
                    value={editItem.village}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="evt123-form-group">
                  <label>Mandal</label>
                  <input
                    type="text"
                    name="mandal"
                    value={editItem.mandal}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              </div>

              <div className="evt123-form-row">
                <div className="evt123-form-group">
                  <label>Date</label>
                  <input
                    type="text"
                    name="date"
                    placeholder="DD-MM-YYYY"
                    value={editItem.date}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="evt123-form-group">
                  <label>Time</label>
                  <input
                    type="text"
                    name="time"
                    placeholder="hh:mm AM/PM"
                    value={editItem.time}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              </div>

              <div className="evt123-modal-footer">
                <button
                  type="button"
                  className="evt123-btn-cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="evt123-btn-save">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminEventsTable;